export { default } from './SubMerchantAggregate.jsx';
